import { useNavigationGuard } from './useNavigationGuard';
import { useSimpleCaseContext } from '../contexts/SimpleCaseContext';
import { useManualSaveMode } from '../contexts/SystemSettingsContext';

export const useWizardNavigation = () => {
    // Try to get context values, but don't fail if context is not available
    let hasUnsavedChanges = false;
    let forceSave: (() => Promise<void>) | undefined;
    let autoSaveEnabled = false;
    let releaseCaseEditingLock: (() => Promise<void>) | undefined;

    try {
        const context = useSimpleCaseContext();
        hasUnsavedChanges = context.hasUnsavedChanges;
        forceSave = context.forceSave;
        // Get auto-save preference from the context
        autoSaveEnabled = context.autoSaveEnabled || false;
        releaseCaseEditingLock = context.releaseCaseEditingLock;
    } catch (error) {
        // Context not available, use defaults
        // This is expected when Navigation is used on non-wizard pages
    }

    const manualMode = useManualSaveMode();

    const navigationGuard = useNavigationGuard({
        isWizardPage: true,
        hasUnsavedChanges,
        forceSave,
        autoSaveEnabled,
        manualMode,
        releaseCaseEditingLock
    });

    const navigateTo = (path: string) => {
        navigationGuard.checkNavigation(path);
    };

    const navigateBack = () => {
        navigationGuard.checkNavigation(-1);
    };

    const navigateForward = () => {
        navigationGuard.checkNavigation(1);
    };

    return {
        navigateTo,
        navigateBack,
        navigateForward,
        ...navigationGuard
    };
};
